<template>
  <ValidationObserver slim>
    <div class="mb-4">
      <SectionTitle class="py-3" content="Traslado de Estudiante" />
      <div class="col-12 py-2">
        <div class="row">
          <div class="col-md-4 col-sm-12 mb-4">
            <ValidationProvider
              v-slot="{ errors, validate: _validate }"
              mode="passive"
              :disabled="!validate"
              :rules="{ required: true }"
              :custom-messages="{
                required: 'Favor seleccionar un servicio.',
              }"
            >
              <label class="input-label">Servicio:</label>
              <CustomDropDown
                v-model="model.institutionServiceCode"
                :disabled="readonly"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                :options="filters.services"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                @input="_validate($event !== null || true)"
              />
            </ValidationProvider>
          </div>
          <div class="col-md-4 col-sm-12 mb-4">
            <ValidationProvider
              v-slot="{ errors, validate: _validate }"
              mode="passive"
              :disabled="!validate"
              :rules="{ required: true }"
              :custom-messages="{
                required: 'Favor seleccionar tipo de escuela.',
              }"
            >
              <label class="input-label">Tipo de Escuela:</label>
              <CustomDropDown
                v-model="model.schoolType"
                fieldkey="id"
                fieldname="name"
                :options="filters.schoolTypes"
                :clearable="false"
                :disabled="true"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                @input="_validate($event !== null || true)"
              />
            </ValidationProvider>
          </div>

          <div class="col-md-4 col-sm-12 mb-4">
            <label class="input-label">Región:</label>
            <ValidationProvider
              v-slot="{ errors, validate: _validate }"
              mode="passive"
              :disabled="!validate"
              :rules="{ required: true }"
              :custom-messages="{
                required: 'Favor seleccionar la región.',
              }"
            >
              <CustomDropDown
                v-model="model.region"
                :disabled="readonly"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                :options="catalog.regions"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                @input="_validate($event !== null || true)"
              />
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-12 mb-4">
            <ValidationProvider
              v-slot="{ errors, validate: _validate }"
              :disabled="!validate"
              mode="passive"
              :rules="{ required: true }"
              :custom-messages="{
                required: 'Favor seleccionar un municipio.',
              }"
            >
              <label class="input-label">Distrito:</label>
              <CustomDropDown
                v-model="model.municipality"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                :options="catalog.municipalities"
                :disabled="readonly || !model.region"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                @input="_validate($event !== null || true)"
              />
            </ValidationProvider>
          </div>
          <div class="col-md-4 col-sm-12 mb-4">
            <ValidationProvider
              v-slot="{ errors, validate: _validate }"
              mode="passive"
              :disabled="!validate"
              :rules="{ required: true }"
              :custom-messages="{
                required: 'Favor seleccionar una escuela.',
              }"
            >
              <label class="input-label">Escuela:</label>
              <CustomDropDown
                v-model="model.destinationLocationSchool"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                :options="catalog.schools"
                :disabled="readonly || !model.municipality"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                @input="_validate($event !== null || true)"
              />
            </ValidationProvider>
          </div>

          <div class="col-md-4 col-sm-12 mb-4">
            <ValidationProvider
              v-slot="{ errors, validate: _validate }"
              :disabled="!validate"
              mode="passive"
              :rules="{ required: true }"
              :custom-messages="{
                required: 'Favor seleccionar una escuela.',
              }"
            >
              <label class="input-label">Residencia:</label>
              <CustomDropDown
                v-model="model.residence"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                :options="filters.residences"
                :clearable="false"
                :disabled="true"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                @input="_validate($event !== null || true)"
              />
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-sm-12 mb-12">
            <ValidationProvider
              v-slot="{ errors, validate: _validate }"
              :disabled="!validate"
              mode="passive"
              :rules="{ required: true }"
              :custom-messages="{
                required: 'Favor agregar un comentario.',
              }"
            >
              <label class="input-label">Comentario:</label>
              <CustomTextArea
                v-model="model.comments"
                :disabled="readonly"
                :maxlength="3000"
                show-char-count
                :count-classes="['d-block text-right']"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                @input="_validate($event !== null || true)"
              />
            </ValidationProvider>
          </div>
        </div>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from 'CustomTextArea';
import alert from '@/mixin/alert.mixin';
import {
  schoolRecommendationCatalogApi,
  getStudentTransferFilters,
  hasValidContractByLocationSchoolId,
} from '@/services/api/tapRequest.api';
import schoolTypes from '@/utils/constants/student/schoolTypes.js';
import InstitutionServiceCodes from '@/utils/constants/pei/ubication-tech-assistance/institutionServiceCodes';

export default {
  name: 'StudentTransfer',
  mixins: [alert],
  components: {
    SectionTitle,
    CustomDropDown,
    CustomTextArea,
  },
  props: {
    request: { type: Object, required: true, default: () => {} },
    modelToSave: { type: Object, default: () => ({}) },
    academicYearId: { type: [Number, String], default: null },
    readonly: { type: Boolean, default: false },
    validate: { type: Boolean, default: false },
  },
  data: () => ({
    catalog: {
      regions: [],
      municipalities: [],
      schools: [],
    },
    filters: {
      districts: [],
      residences: [],
      regions: [],
      schoolTypes: [],
      schools: [],
      services: [],
    },
    model: {
      municipality: null,
      residence: null,
      region: null,
      schoolType: null,
      destinationLocationSchool: null,
      institutionServiceCode: null,
      comments: null,
      hasValidContract: null,
    },
  }),
  methods: {
    async getRegions() {
      const data = await schoolRecommendationCatalogApi.getRegions({
        academicYearId: this.academicYearId,
      });

      this.catalog.regions = data;
    },
    async getDistricts({ regionId }) {
      if (!regionId) return;
      const data = await schoolRecommendationCatalogApi.getDistricts({
        academicYearId: this.academicYearId,
        regionId,
        schoolTypes: [schoolTypes.Institutions],
      });

      this.catalog.municipalities = data;
    },
    async getSchools({ regionId, districtId }) {
      if (!regionId || !districtId) return;

      const data = await schoolRecommendationCatalogApi.getSchools({
        academicYearId: this.academicYearId,
        regionId,
        districtId,
      });
      this.catalog.schools = data;
    },
    async getData() {
      await this.getFilters();
      this.$emit('update:modelToSave', this.model);
    },
    async getFilters() {
      const { data } = await getStudentTransferFilters(this.model);
      this.filters = {
        ...data,
        services: data.services
          .filter((x) => x.name != 'N/A')
          .map((c) => {
            return { ...c, name: c.name.split(/(?=[A-Z])/).join(' ') };
          }),
      };
      this.model.residence = {
        id: this.request?.municipality?.id,
        name: this.request?.municipality?.name,
      };
      this.model.schoolType = this.filters.schoolTypes[0];
      this.$emit('update:modelToSave', this.model);
    },
    async hasSchoolEffectiveContract() {
      const { data: hasContract } = await hasValidContractByLocationSchoolId(
        this.model.destinationLocationSchool?.id
      );
      if (!hasContract) {
        this.model.hasValidContract = false;
        this.ShowToast(
          '',
          'La escuela seleccionada no cuenta con un contrato vigente en sistema.',
          'error'
        );
      } else {
        this.model.hasValidContract = true;
      }

      this.$emit('update:modelToSave', this.model);
      this.$emit('on-valid-contract-change', this.model.hasValidContract);
    },
  },
  watch: {
    model: {
      async handler() {
        if (this.doWatch) return;
        this.model = this.modelToSave;
        if (this.model) {
          await this.getDistricts({ regionId: this.model.region?.id });
          await this.getSchools({
            regionId: this.model.region?.id,
            districtId: this.model.municipality?.id,
          });
        }
        this.doWatch = true;
      },
      deep: true,
      immediate: true,
    },
    'model.region': {
      async handler(value) {
        if (!this.doWatch) return;

        this.catalog.municipalities = [];
        this.model.municipality = null;

        if (!value?.id) return;
        await this.getDistricts({ regionId: value?.id });
      },
      deep: true,
    },
    'model.municipality': {
      async handler(value) {
        if (!this.doWatch) return;

        this.catalog.schools = [];
        this.model.destinationLocationSchool = null;
        if (!value?.id || !this.model.region?.id) return;
        await this.getSchools({
          regionId: this.model.region?.id,
          districtId: value?.id,
        });
      },
      deep: true,
    },
    'model.destinationLocationSchool': {
      async handler(value) {
        if (
          value &&
          value?.id > 0 &&
          this.model.institutionServiceCode?.id ==
            InstitutionServiceCodes.ServicePurchase
        ) {
          this.hasSchoolEffectiveContract();
        }
        this.$emit(
          'on-therapy-service-reset',
          this.model.destinationLocationSchool?.id
        );
      },
    },
  },
  async created() {
    await Promise.all([this.getRegions(), this.getFilters()]);
  },
};
</script>
